import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class StandTag extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      standKey: null,
      standCode: '',
      standCodeErrorText: '',
      stand: {
        key: '',
        name: '',
        description: '',
        coordinates: '',
        standTag: {
          code: ''
        }
      }
    };

    this.state = {
      ...this.initialState
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.stand) {
      this.setState({stand: nextProps.stand});
      if (nextProps.stand.standTag) {
        if (nextProps.stand.standTag.code) {
          this.setState({standCode: nextProps.stand.standTag.code});
        }
      }
    }
  }

  validateStandCode = () => {
    const {t} = this.props;
    if (this.state.standCode) {
      if (this.state.standCode.toString().length === 5 ) {
        return true;
      } else {
        this.setState({standCodeErrorText:t('stand.code5chars')});
        return false;
      }

    } else {
      this.setState({standCodeErrorText:t('stand.codeRequired')});
      return false;
    }
  }

  handleRegister = () => {
    const {t, firebase, user} = this.props;

    if (this.validateStandCode()) {
      const standCodeRef = firebase.database().ref(`standcodes/${this.state.standCode}`);
      standCodeRef.once('value').then((data) => {
        if (data.val()) {
          if (!data.val().ref) {
            const ref = `shopkeepers/${user.shopkeeperId}/stands/${this.state.stand.key}`;
            firebase.database().ref(`standcodes/${this.state.standCode}`).set({ref});
            firebase.database().ref(`${ref}/standTag`).set({code: this.state.standCode});
            this.props.handleClose();
          } else {
            this.setState({standCodeErrorText:t('stand.codeInUse')});
          }
        } else {
          this.setState({standCodeErrorText:t('stand.codeWrong')});
        }
      });
    }
  }
  handleStandCodeChange = (event, standCode) => {
    this.setState({standCodeErrorText: '', standCode});
  }
  handleClose = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleRegister}
      />,
    ];

    return (
      <Dialog title={t('stand.tag')}
      open={this.props.open}
      onRequestClose={this.handleClose}
      actions={actions}>
          <TextField hintText={t('stand.code')}
            floatingLabelText={t('stand.code')}
            errorText={this.state.standCodeErrorText}
            onChange={this.handleStandCodeChange}
            onBlur={this.validateStandCode}
            value={this.state.standCode}
          />
      </Dialog>

    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(StandTag);



// WEBPACK FOOTER //
// ./src/Stand/StandTag.js